import { sagas as autoPaymentsSagas } from './modules/autoPayments'
import { sagas as paymentMethodSagas } from './modules/paymentMethods'
import { sagas as paymentsSagas } from './modules/payments'
import { sagas as repaymentPlansSagas } from './modules/repaymentPlans'
import { sagas as repaymentsSagas } from './modules/repayments'
import { sagas as refundMethodSagas } from './modules/refundMethod'
import { sagas as moneygramSagas } from './modules/moneygram'

export default [
  ...autoPaymentsSagas,
  ...paymentMethodSagas,
  ...paymentsSagas,
  ...repaymentPlansSagas,
  ...repaymentsSagas,
  ...refundMethodSagas,
  ...moneygramSagas,
]
